import React, { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Tabs, Tab, Box } from "@mui/material";

import Exhibitors from "./Exhibitors/Exhibitors";
import Booths from "./Booths/Booths";

const theme = createTheme({
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: "bold",
          textTransform: "none",
          "&.Mui-selected": {
            color: "#F68A20",
          },
          "&:not(.Mui-selected)": {
            color: "black",
          },
        },
      },
    },
  },
  palette: {
    secondary: {
      main: "#F68A20",
    },
  },
});
// Helper function to customize Tab label
const formatLabel = (label) =>
  `${label.charAt(0).toUpperCase()}${label.slice(1).toLowerCase()}`;

const Exhibition = ({ userID, token, eventDetails }) => {
  const [selectedTab, setSelectedTab] = useState("0");
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  // console.log("eventDetails?.eventType...", eventDetails?.eventType);
  return (
    <ThemeProvider theme={theme}>
      <div className="set-event-rightbar-content">
        <Box
          sx={{ backgroundColor: "white", width: "100%" }}
          className="set-event-rightbar-content-hearder"
        >
          <div
            className="w-100 d-flex justify-content-center pt-2"
            style={{
              position: "fixed",
              backgroundColor: "white",
              marginLeft: "-10%",
            }}
          >
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              textColor="secondary"
              indicatorColor="secondary"
              aria-label="community navigation tabs"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
            >
              <Tab value="0" label={formatLabel("Exhibitors")} />
              <Tab value="1" label={formatLabel("Booths")} />
            </Tabs>
          </div>
        </Box>

        {selectedTab === "0" && (
          <div className="px-5 py-4">
            <Exhibitors
              userID={userID}
              token={token}
              eventID={eventDetails?._id}
              eventDetails={eventDetails}
            />
          </div>
        )}
        {selectedTab === "1" && (
          <div className="px-5 py-4">
            <Booths userID={userID} token={token} eventID={eventDetails?._id} />
          </div>
        )}
      </div>
    </ThemeProvider>
  );
};

export default Exhibition;
